<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">沟通用语</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>VIP类型：</label>
          <el-select v-model="vipState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in vipStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>顺序：</label>
          <el-select v-model="orderNum" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in orderNumArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>分状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>总状态：</label>
          <el-select v-model="stateAll" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateAllArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>推荐状态：</label>
          <el-select v-model="recommendState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in recommendStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="更新时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>
          <el-button type="success" v-loading="updateLoading" @click="batchUpdate(2)">批量通过</el-button>
          <el-button type="danger" v-loading="updateLoading" @click="batchUpdate(3)">批量不通过</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
        >
          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>
          <el-table-column property="updateTime" label="更新时间" v-if="checkColList.indexOf('更新时间') > -1"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户" v-if="checkColList.indexOf('用户') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
            </template>
          </el-table-column>
          <el-table-column property="" label="顺序" v-if="checkColList.indexOf('顺序') > -1">
            <template #default="scope">
              第{{scope.row.orderNum==1?'一':scope.row.orderNum==2?'二':scope.row.orderNum==3?'三':''}}句
            </template>
          </el-table-column>
          <el-table-column property="msg" label="内容" v-if="checkColList.indexOf('内容') > -1"></el-table-column>
          <el-table-column prop="" label="分状态" v-if="checkColList.indexOf('分状态') > -1">
            <template #default="scope">
              {{scope.row.state==-1?'未提交':scope.row.state==0?'待审核':scope.row.state==1?'待审核':scope.row.state==2?'已通过':scope.row.state==3?'不通过':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="总状态" v-if="checkColList.indexOf('总状态') > -1">
            <template #default="scope">
              <span>{{scope.row.stateAll==0?'待审核':scope.row.stateAll==1?'待审核':scope.row.stateAll==2?'已通过':scope.row.stateAll==3?'不通过':''}}</span>
              ：
              <span>{{(!scope.row.recommendState||scope.row.recommendState==2)?'正常推荐':scope.row.recommendState==1?'已取消推荐':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space direction="vertical" alignment="left">
                <el-button v-if="!scope.row.recommendState||scope.row.recommendState==2" type="danger" size="small" @click="updateReState(scope.$index, scope.row, 1)" v-loading="scope.row['reLoading']">取消推荐</el-button>
                <el-button v-if="scope.row.recommendState==1" type="success" size="small" @click="updateReState(scope.$index, scope.row, 2)" v-loading="scope.row['reLoading']">恢复推荐</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
  getGreetingTermPageList,
  updateGreetingTermState,
  updateGreetingTermRecommendState
} from '../../api/url'
import {getFormData, postFormData} from '@/api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import SendSystemMessageChat from "@/components/SendSystemMessageChat";

export default {
  name: "GreetingReview",
  components: { DatePickerRange, SearchComponents, UserLog },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[1]['value'],

      //VIP
      vipStateArray:[
        {label : '不限制', value : -1},
        {label : '非vip', value : 0},
        {label : 'vip未过期', value : 1},
        {label : 'vip已过期', value : 2},
        {label : '终身vip', value : 3}
      ],
      vipState: -1,

      //顺序
      orderNumArray: [
        {value: -1, label: '不限制'},
        {value: 1, label: '第一句'},
        {value: 2, label: '第二句'},
        {value: 3, label: '第三句'}
      ],
      orderNum: -1,

      //分状态
      stateArray: [
        {value: -2, label: '不限制'},
        {value: -1, label: '未提交'},
        {value: 1, label: '待审核'},
        {value: 2, label: '已通过'},
        {value: 3, label: '不通过'}
      ],
      state: 1,

      //总状态
      stateAllArray: [
        {value: -2, label: '不限制'},
        {value: 1, label: '待审核'},
        {value: 2, label: '已通过'},
        {value: 3, label: '不通过'}
      ],
      stateAll: 1,

      //推荐状态
      recommendStateArray: [
        {value: -1, label: '不限制'},
        {value: 2, label: '正常推荐'},
        {value: 1, label: '已取消推荐'}
      ],
      recommendState: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['更新时间', '头像', '用户', '顺序', '内容', '分状态', '总状态', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = 1;
      this.vipState = -1;
      this.state = 1;
      this.orderNum = -1;
      this.stateAll = 1;
      this.recommendState = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['vipState'] = this.vipState;
      param['state'] = this.state;
      param['orderNum'] = this.orderNum;
      param['stateAll'] = this.stateAll;
      param['recommendState'] = this.recommendState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getGreetingTermPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

    },


    //批量审核
    batchUpdate(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量'+ (state == 2?'【通过】':'【不通过】') +'选中的用户？').then(()=>{
          this.updateLoading = true;
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray;
          param['state'] = state;
          postFormData(updateGreetingTermState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.updateLoading = false;
          })
              .catch(()=>{
                _this.updateLoading = false;
              })
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    //推荐
    updateReState(idx, row, state) {
      this.$confirm('确定' + (state == 1?'取消':'恢复') +'【' + row.nickName + '】的新人推荐?').then(()=>{
        this.pageDataList[idx]['reLoading'] = true
        let param = {}
        param['id'] = row.userId
        param['state'] = state
        postFormData(updateGreetingTermRecommendState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            for(let i=0;i<this.pageDataList.length;i++){
              if(this.pageDataList[i]['userId'] == this.pageDataList[idx]['userId']){
                this.pageDataList[i]['recommendState'] = state;
              }
            }
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['reLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['reLoading'] = false
        })
      })
    },

    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessageChat,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
